import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  deleteDoc,
} from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button } from "reactstrap";

function AdminSingleBannerPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const bannerUid = params.bannerUid;

  const [image, setImage] = useState();

  const fetchBanners = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "homePageBanners"),
        where("uid", "==", bannerUid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setImage(data.url);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching banner data");
    }
  };

  useEffect(() => {
    if (bannerUid) {
      fetchBanners();
    }
    // eslint-disable-next-line
  }, [bannerUid]);

  const deleteBanner = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this banner?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const bannerRef = query(
            collection(db, "homePageBanners"),
            where("uid", "==", bannerUid)
          );
          const findBanners = await getDocs(bannerRef);
          findBanners.forEach(async (bannerObject) => {
            const getBanner = doc(db, "homePageBanners", bannerObject.id);
            await deleteDoc(getBanner);
          });

          Swal.fire({
            text: "Banner deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting reward");
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        BANNER
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
        </div>
        <Button
          onClick={deleteBanner}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleBannerPage;
